<app-dashboard-card-small
  *ngFor="let smallCardsdata of smallCardsdata"
  cardTitle="{{ smallCardsdata.cardTitle }}"
  iconLink="{{ smallCardsdata.iconLink }}"
  followersNumber="{{ smallCardsdata.followersNumber }}"
  statusIconLink="{{ smallCardsdata.statusIconLink }}"
  statusColor="{{ smallCardsdata.statusColor }}"
  followersPercentage="{{ smallCardsdata.followersPercentage }}"
></app-dashboard-card-small>
